module.exports = __webpack_public_path__ + "img/21de659958f93be3518dbc411ad4b5e9.png";